import { Component, OnInit, OnDestroy } from '@angular/core';
import { PopupBaseComponent } from 'src/app/components/common/popup-base/popup-base.component';
import { PedigreeService } from '../pedigree/pedigree.service';
import { OverlayService } from 'src/app/services/UI/overlay.service';
import { PopupResponse, PedigreePopupResponse } from 'src/app/common/models/PopupResponse';
import { PopupResponseEvents } from 'src/app/common/enums/enums';
import { PedigreeOptionPopupInputInfo } from 'src/app/common/models/PopupInputInfo';
import { PedigreeOptionInfo } from 'src/app/common/models/ReportOptionInfo';

@Component({
    selector: 'app-pedigreeoptionpopup',
    templateUrl: './pedigreeoptionpopup.component.html',
    styleUrls: ['./pedigreeoptionpopup.component.scss'],
    standalone: false
})
export class PedigreeoptionpopupComponent extends PopupBaseComponent implements OnInit, OnDestroy {

  titleOption: string;
  isSaveEnable: boolean = false;
  pedigreeServiceSubscription: any
  dropDownData = [1, 2, 3, 4, 5, 6];
  selectedGenaration = 5;
  reportTitle = ""
  transitionVal: any;

  constructor(private pedgreeService: PedigreeService, overlayService: OverlayService) {
    super(pedgreeService, overlayService);
  }

  ngOnInit(): void {
    this.show();
    this.display();
  }

  /**
      * Display report option popup 
      */
  display() {
    this.isSaveEnable = false;
    this.pedigreeServiceSubscription = this.pedgreeService.onVisibilityChanged().subscribe((data: PedigreeOptionPopupInputInfo) => {
      this.popupWidth = data.popWidth;
      console.log(data)
      this.titleOption = data.TitleOption;
      this.selectedGenaration = data.Genaration;
      this.reportTitle = data.ReportTitle;
    })
  }


  /**
   * Save selected report options
   */
  selected() {
    console.log("selected clicked");
    this.isSaveEnable = false;
    let sunChartPopupInfo = new PedigreePopupResponse();
    let sunOptions = new PedigreeOptionInfo();
    sunOptions.generations = this.selectedGenaration;
    sunOptions.title = this.reportTitle;
    sunChartPopupInfo.Info = sunOptions;
    this.pedgreeService.setSelection(sunChartPopupInfo);
    this.pedgreeService.changeVisibility(false, null);
  }

  /**
   * Change genaration number
   */
  onChange(event) {
    console.log(event.target.value);
    this.selectedGenaration = event.target.value
  }

  cancel() {
    this.isSaveEnable = false;
    let popupResponse = new PopupResponse();
    popupResponse.Status = PopupResponseEvents.Cancelled;

    this.pedgreeService.setSelection(popupResponse);
    this.pedgreeService.changeVisibility(false, null);
  }


  ngOnDestroy() {
    this.pedigreeServiceSubscription.unsubscribe();
  }
}
